import React from 'react';
import { IField, IGroundTruth, IDocument } from '../../../types/my-types';
import GroundTruthField from './GroundTruthField';

import MarkReviewFormStyles from './MarkReviewForm.module.scss';
export interface FieldListProps {
  groundTruths: IGroundTruth[];
  fields: IField[];
  doc: IDocument;
  trainingSetId: string;
}

const FieldList: React.FC<FieldListProps> = ({ doc, fields, groundTruths, trainingSetId }) => {
  return (
    <form
      id="ground-truth-form"
      data-cy={'ground-truth-form'}
      className={MarkReviewFormStyles.fieldList}
    >
      {fields.map((field, index) => {
        // match ground truth with field id
        const groundTruth = groundTruths.find((g) => g.field === field.url);
        return (
          <GroundTruthField
            key={field.id}
            index={index}
            field={field}
            fields={fields}
            fieldDataType={field.data_type}
            fieldDataTypeConfig={field.data_type_config}
            fieldsCount={fields.length}
            fieldId={field.id}
            doc={doc}
            groundTruth={groundTruth}
            trainingSetId={trainingSetId}
          />
        );
      })}
    </form>
  );
};

export default FieldList;
